"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[378],{

/***/ 20353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function getBorderColor(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eecfaa46-0"
}).withConfig({
    componentId: "sc-62e22978-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-eecfaa46-1"
}).withConfig({
    componentId: "sc-62e22978-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx






var Card = function Card(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 2164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Spinner_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/PanIcon.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 340 323"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#3F1C10",
                    d: "M267.9,61.7c-0.3,16.2-3,31.8-8.4,47.1c-0.3,1.2-0.6,2.4,0,3.6c3.3,7.5,5.7,15.3,6.9,23.1 c3.6,23.7-3.6,43.2-23.1,57.6c-3.9,3-8.1,5.4-12.6,7.5c-1.2,0.6-1.2,0.9-0.6,2.1c4.2,6.9,7.5,14.1,9.3,21.6 c1.5,5.7,2.7,11.1,3,17.1c0,1.8,0.9,2.4,2.4,3c6,1.5,10.8,4.5,13.5,10.5c1.5,3.6,1.8,7.5,1.2,11.4c-0.9,7.2-3.6,13.5-7.2,19.8 c-0.3,0.6-0.6,1.2-0.9,1.8c-0.6,0.9-0.6,1.5,0.6,2.1c1.5,0.6,2.4,1.8,3.3,3c3.6,4.5,2.1,10.8-3,14.1c-7.2,4.5-14.1,3-21-0.9 c-1.8-0.9-3.3-2.4-4.8-3.9c-0.9-0.6-1.2-0.6-1.8,0.3c-0.9,1.2-1.5,2.1-2.7,3c-2.1,1.5-3.9,2.1-6.3,0.6c-0.6-0.3-1.2-0.6-2.1,0 c-3.9,3-8.1,3-12.3,0.6c-0.9-0.6-1.8-0.6-2.7-0.6c-3.9,0.6-8.4-0.9-9.9-5.1c-0.3-0.9-0.9-0.9-1.8-0.6c-11.7,4.5-23.7,4.5-35.4,0 c-0.9-0.3-1.5,0-1.8,0.9c-0.6,1.8-1.8,3-3.3,4.2c-1.8,1.5-3.9,1.8-6,0.6c-0.6-0.3-1.2-0.6-2.1,0c-3.9,3-8.1,3-12.3,0.6 c-0.9-0.6-1.8-0.6-2.7-0.6c-3.9,0.3-7.5-0.6-9.6-4.2c-0.6-1.2-1.2-0.3-1.8,0c-3,3-6.6,5.1-10.8,6.3c-4.5,1.2-9,0.9-13.2-1.8 c-6-3.9-6.3-11.7-0.3-16.2c1.5-1.2,1.5-2.1,0.6-3.6c-3.3-5.7-6-11.7-7.2-18c-1.2-6.3-0.9-12.6,3-18c2.7-3.9,6.6-5.7,11.1-6.9 c1.5-0.3,1.8-0.9,1.8-2.4c0.9-11.1,3.3-21.9,8.4-31.8c1.2-2.4,2.7-4.8,4.2-6.9c0.9-1.2,0.6-1.8-0.6-2.4 c-8.7-4.2-16.5-9.9-22.8-17.4c-9.3-10.8-13.2-23.7-12.9-37.8c0.3-11.1,2.7-21.6,6.6-31.8c0.3-0.9,0.6-1.5,0-2.7 c-2.7-6-4.2-12.3-5.4-18.6c-3-16.2-3.3-32.7-0.9-49.2c1.2-9,3.6-17.7,8.4-25.5c1.5-2.7,3-3.9,6.3-3.6c14.4,1.2,27.9,5.4,39.6,14.1 c6.3,4.8,11.7,10.2,16.8,16.2c1.2,1.2,2.1,1.5,3.6,1.2c12.3-2.4,24.6-2.7,37.2-0.9c0.9,0,1.8,0,2.4,0.3c3.3,1.5,5.1,0,7.2-2.7 c10.5-11.7,22.8-20.1,37.5-25.5c5.7-2.1,11.4-3,17.4-3.3c2.4,0,4.2,0.6,5.7,2.7c3.9,5.4,6.3,11.7,8.1,18c0.9,3,1.5,6,2.1,9 C267.6,49.7,268.2,55.7,267.9,61.7z M216.1,284.6C216.1,284.3,216.1,284.3,216.1,284.6C216.1,284.3,216.1,284.3,216.1,284.6 C216.1,284.3,216.1,284.3,216.1,284.6c-0.3,0.6,0,1.2,0.3,1.8c1.5,5.1,2.1,10.2,0.3,15.3c-0.3,1.2,0.6,2.4,2.1,2.1 c0.9-0.3,1.8-0.6,2.4-1.5C225.7,296.9,222.7,287,216.1,284.6z M124.9,284c-0.3,0-0.6,0-0.9,0.3c-4.8,3.3-7.8,7.8-7.8,13.8 c0,3.3,2.4,5.4,5.7,5.4c1.2,0,2.1-0.3,1.8-1.8c-0.9-3.3-0.6-6.6-0.6-9.9C123.1,289.1,124.6,286.7,124.9,284L124.9,284L124.9,284 L124.9,284z M193.9,278.3c0.6-1.5,0.3-3,0-4.5c-0.3-6-1.2-12-3.9-17.7c-0.6-1.2-2.1-2.4-0.3-3.6c1.5-1.2,2.1,0.9,3,1.8 c2.7,6.9,4.2,14.1,4.2,21.6c0,1.8,0,3.6,0,5.7c6-3.3,12-3.9,18-1.2c6.3,2.7,10.2,6.9,11.1,13.8c0.6,0,0.6-0.3,0.9-0.6 c4.5-7.5,8.1-15.6,10.2-24.3c1.2-4.5,2.1-9,2.1-13.5c0.3-1.5,0.3-3,0.6-4.5c0.3-8.1-0.6-15.9-2.4-23.7c-1.5-6.6-3.9-12.9-7.2-18.9 c-0.6-1.2-1.5-2.4-2.1-3.6c-0.9-1.5-1.8-2.1-3.6-1.2c-0.6,0.6-1.5,0.6-2.4,0.9c-4.5,2.1-9.3,3-13.8,4.8c-9.6,2.7-19.2,3.6-29.1,3.9 c-15.9,0.6-31.8-0.9-47.4-4.5c-4.2-1.2-8.1-2.1-12.3-3.6c-1.8-0.6-4.2-2.4-5.7-1.8c-1.8,0.6-2.4,3.3-3.6,5.1 c-4.8,8.1-7.2,16.5-8.7,25.8c-0.9,6.6-1.5,13.2-0.9,19.8c0,0.3-0.3,0.6,0,0.9c0.6,6.3,1.5,12.9,3,19.2c1.8,6.6,4.2,13.2,8.1,19.2 c0.3,0.6,0.6,1.5,1.5,1.5c0.6,0,0.6-0.9,0.6-1.5c2.4-9.6,13.2-15.9,22.8-13.5c2.7,0.6,5.4,1.8,8.1,3.6c-0.3-2.4-0.3-4.5-0.6-6.6 c0-4.2,0.3-8.4,1.2-12.6c0.6-3.3,1.5-6.3,2.4-9.6c0.9-0.9,1.2-2.7,2.7-1.8c1.8,0.9,0.6,2.1,0,3.3c-2.4,6.9-3.3,13.8-3,20.7 c-0.3,0.3-0.3,0.6,0,0.9c0,0.9,0,1.5,0.3,2.4c0,3,0.6,5.7,1.8,8.4c1.2,2.4,2.1,4.8,1.8,7.5c0,0.9,0.3,1.5,1.2,1.8 c11.4,4.5,23.1,4.5,34.5,0c0.9-0.3,1.2-0.9,1.2-1.8c0.3-3.3,1.5-6.3,3.3-8.7C193.6,284.3,193.9,281.6,193.9,278.3L193.9,278.3z M77.8,156.8c-0.3,0.6,0,1.5,0.3,2.1c2.1,9.6,6.6,18,13.5,25.2c9.3,9.6,20.7,15.6,33.3,19.5c13.8,4.5,27.9,6.3,42.3,6.6 c11.4,0.3,22.8,0,33.9-2.1c10.8-2.1,21-6,30.9-11.1c11.1-5.7,20.7-13.5,26.7-24.6c3.9-7.2,6-15,6.3-23.1c0.3-0.9,0.3-1.8,0-2.7 c0-0.6,0-1.2,0-1.8c-0.6-11.1-3.6-21.6-7.8-31.8c-6-14.4-14.4-27.3-24.3-39.3c-2.1-2.7-3.6-5.1-3.9-8.7c-0.6-6.6-0.6-13.2,1.2-19.5 c2.1-9.3,7.2-16.8,14.1-23.4c1.5-1.5,3-2.7,5.1-4.5c-4.2,0-7.8,0.9-11.1,1.8c-6.9,2.1-13.5,5.1-19.8,9 c-7.5,4.8-14.1,10.2-20.1,17.1c-0.9,1.2-0.9,1.5,0.6,2.1c4.8,1.5,9.3,3.3,13.2,6.3c0.9,0.6,1.8,1.5,1.2,2.7 c-0.9,1.2-1.8,0.6-2.7-0.3c-2.4-2.1-5.1-3.3-8.1-4.5c-9-3.6-18.6-4.8-28.2-5.1c-12.6-0.3-24.6,0.9-36.3,6c-2.1,0.9-4.2,2.1-6.3,3.3 c-0.9,0.6-1.5,0.6-2.1-0.3c-0.6-0.9-0.3-1.5,0.3-2.1c0.3-0.3,0.9-0.6,1.2-0.9c4.2-2.7,9-4.2,13.5-5.7 c-7.2-13.5-38.1-31.2-50.1-28.8c4.5,3.3,8.4,7.5,11.4,12c7.5,12,9.6,24.6,5.7,38.4c-0.3,1.2-0.6,2.1-1.2,3 c-2.7,3.9-5.7,7.5-8.4,11.4c-8.7,12.3-16.5,25.2-20.7,39.9c-2.1,7.5-3.6,15-3.3,22.5C76.6,149.3,76.9,153.2,77.8,156.8z M82.6,108.2c0.3-0.6,0.6-0.6,0.6-0.9c5.7-11.7,12.9-22.5,20.4-33c1.5-2.1,3.3-3.9,4.2-6.3c3-9.9,2.4-19.8-1.8-29.1 c-3.9-8.7-9.6-15.9-18-20.4c-1.5-0.9-2.1-0.3-2.7,0.6c-1.5,2.7-3,5.4-3.9,8.4c-3.6,9.9-5.1,20.1-5.4,30.6 c-0.6,13.5,0.6,26.7,3.3,39.9C80.2,101.3,81.1,104.6,82.6,108.2z M257.5,106.4c0.3-0.9,0.6-1.5,0.9-1.8c2.1-6.9,3.9-14.1,5.1-21.3 c2.1-12.6,2.7-25.2,0.6-38.1c-1.5-9-3.9-17.7-9-25.5c-0.9-1.5-1.5-1.5-3-0.6c-15.3,10.8-22.2,25.5-20.4,44.1 c0.3,2.7,0.6,5.1,2.7,7.5c6.9,7.8,12.9,16.5,18,25.5C253.9,99.2,255.4,102.5,257.5,106.4z M257.2,265.1c0-10.2-3.9-15.3-12.3-17.7 c-1.5-0.6-1.8,0-1.8,1.5c0,6.9-0.6,13.5-2.4,20.1c-2.4,10.2-6.6,19.8-12.6,28.8c-0.6,0.9-0.6,1.5,0.3,2.4c3.9,3.3,8.1,6,13.2,6.6 c4.5,0.6,8.4-0.9,11.4-4.5s1.5-8.1-3.3-10.5c-2.4-1.2-5.1-1.8-7.8-2.1c-1.2,0-1.8-0.6-1.8-1.8c0-1.2,1.2-1.5,2.1-1.2 c0.3,0,0.6,0,0.9,0c5.1,0.9,5.1,0.9,7.5-3.3c0,0,0-0.3,0.3-0.3C254.2,276.8,256.9,270.2,257.2,265.1z M97.6,305.9 c5.1-0.3,9.6-3,13.5-6.9c0.9-0.9,0.3-1.5-0.3-2.1c-4.5-6-7.5-12.9-9.6-20.1c-2.7-9.3-3.9-18.6-3.9-28.2c0-1.8-0.3-2.1-2.1-1.5 c-7.5,2.4-11.7,7.8-11.4,15.6c0.3,8.7,3.6,16.5,8.1,23.7c0.6,0.9,1.2,1.2,2.1,0.6c1.2-0.6,2.4-0.9,3.6-1.2c0.9,0,2.1-0.3,2.4,0.9 c0.3,1.5-0.6,1.8-1.8,2.1c-2.4,0.6-4.8,1.5-7.2,2.7c-4.8,2.7-6,7.2-3,10.8C90.7,305,93.7,305.9,97.6,305.9z M139.6,294.5 c0-3.9-0.6-7.5-2.7-10.8c-1.5-2.7-6.6-2.7-8.1,0c-3,5.4-3.9,11.1-2.4,16.8c0.3,1.2,0,2.4,1.2,3.3c3.6,2.7,9.3,1.2,11.1-3 C139.6,299,139.6,296.9,139.6,294.5z M200.8,295.4c0,0.9,0,1.8,0,3c0.3,2.1,0.3,4.2,1.8,5.7c2.4,2.1,9,2.4,10.5-2.1 c2.1-6.3,1.8-12.3-1.5-18.3c-1.2-2.4-6.3-2.4-7.8-0.3C201.7,287,200.8,290.9,200.8,295.4z M200.2,283.7c-5.7,2.4-9.3,8.4-9,14.7 c0,3.3,2.7,5.4,6.3,5.1c0.9,0,1.2-0.6,0.9-1.5C197.2,295.7,197.5,289.7,200.2,283.7z M141.1,284.6c0,0.3,0,0.3,0,0.6 c1.8,5.7,2.1,11.1,0.6,16.8c-0.3,1.8,0.9,1.8,2.1,1.8c0.9,0,1.5-0.6,2.4-1.2c1.5-1.5,1.8-3.3,2.1-5.4 C148.9,292.1,145.3,285.8,141.1,284.6z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#F3A32F",
                    d: "M76.9,145.7c0-7.8,1.2-15.3,3.3-22.5c4.5-14.7,12.3-27.6,20.7-39.9c2.7-3.9,5.7-7.8,8.4-11.4 c0.6-0.9,0.9-1.8,1.2-3c3.9-13.8,1.8-26.4-5.7-38.4c-3-4.8-6.9-8.7-11.4-12c12-2.4,42.9,15.3,50.1,28.8c-4.8,1.5-9.3,3.3-13.5,5.7 c-0.3,0.3-0.9,0.3-1.2,0.9c-0.6,0.6-0.9,1.5-0.3,2.1c0.6,0.9,1.2,0.9,2.1,0.3c2.1-1.2,3.9-2.4,6.3-3.3c11.7-5.1,24-6.3,36.3-6 c9.6,0.3,19.2,1.5,28.2,5.1c3,1.2,5.7,2.4,8.1,4.5c0.9,0.6,2.1,1.5,2.7,0.3c0.9-1.2-0.3-2.1-1.2-2.7c-3.9-3-8.4-4.8-13.2-6.3 c-1.8-0.6-1.8-0.9-0.6-2.1c6-6.6,12.6-12.3,20.1-17.1c6.3-3.9,12.6-7.2,19.8-9c3.6-0.9,6.9-1.8,11.1-1.8c-2.1,1.8-3.6,3-5.1,4.5 c-6.9,6.3-11.7,14.1-14.1,23.4c-1.5,6.3-1.8,12.9-1.2,19.5c0.3,3.6,1.8,6,3.9,8.7c9.9,12,18.3,24.9,24.3,39.3 c4.5,10.2,7.2,20.7,7.8,31.8c0,0.6,0,1.2,0,1.8c-2.7-0.9-5.4-2.1-8.4-2.7c-11.1-2.7-22.5-3-33.6,0.3c-3,0.9-6,2.4-8.1,4.8 c-1.2,1.5-1.8,1.5-3,0c-5.7-6.3-12-11.7-19.5-15.6c-9.9-5.1-20.4-6.9-31.5-4.5c-12.3,2.7-21.9,9.6-29.7,19.2 c-1.2,1.5-1.8,1.2-3,0.6c-8.1-4.8-17.1-7.5-26.4-8.1C92.8,140.3,84.7,142.1,76.9,145.7z M233.5,115.4c0-7.8-2.4-14.4-8.4-19.8 c-6-5.7-14.7-6.3-21.6-1.8c-4.5,3-7.5,7.2-9,12.3c-3,9.6-1.8,18.9,4.8,26.7c7.2,8.7,18.6,9.3,26.7,1.5 C231.1,129.2,233.2,122.9,233.5,115.4z M107.8,117.5c-0.3,3.3,1.2,8.1,3.9,12.3c6.3,11.4,20.1,13.5,29.4,4.5 c9.3-9.3,9.6-27.9,0.3-37.2c-6.9-6.9-15.9-8.1-23.4-2.7C110.5,99.5,107.8,107,107.8,117.5z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#FEFEFE",
                    d: "M76.9,145.7c7.8-3.6,15.9-5.4,24.3-4.8c9.6,0.6,18.3,3.3,26.4,8.1c1.2,0.9,1.8,0.9,3-0.6 c7.5-9.9,17.4-16.5,29.7-19.2c10.8-2.4,21.3-0.6,31.5,4.5c7.5,3.9,14.1,9.3,19.5,15.6c1.2,1.2,1.8,1.5,3,0c2.1-2.7,5.1-3.9,8.1-4.8 c11.1-3.3,22.5-3,33.6-0.3c3,0.6,5.7,1.8,8.4,2.7c0,0.9,0,1.8,0,2.7c-0.9,0.3-1.2,1.2-1.5,1.8c-1.5,3.6-3.3,7.2-5.1,10.5 c-4.2,7.2-9.6,13.5-15.6,19.2c-4.5,3.9-9,7.2-14.1,10.2c-8.4,4.8-17.4,7.8-27,9.9c-6.9,1.5-13.8,2.4-20.7,2.4c-6.9,0-14.1,0-21-0.6 c-7.5-0.9-15-2.1-22.2-4.2c-10.2-2.7-19.8-6.6-29.1-11.4c-6.6-3.6-12.9-7.8-18.3-13.2c-4.8-4.5-8.7-9.9-11.4-15.9 c-0.3-0.6-0.3-1.2-1.2-1.2C76.9,153.2,76.6,149.3,76.9,145.7z M172,202.7c0.3,0.6,0.6,0.3,0.9,0c6.3-1.2,11.7-4.5,15.6-9.6 c3.6-4.2,6-9,8.1-14.1c0.3-0.9,0.9-1.5,1.8-2.1c3-1.5,5.4-3.6,7.5-6.3c0.9-1.2,1.8-2.7,2.4-3.9c0.6-0.9,0.6-1.8-0.6-2.4 c-0.9-0.6-1.8,0.3-2.1,0.9s-0.6,1.2-0.9,1.5c-3,5.1-7.5,8.1-13.2,9c-6.6,0.9-12.6-1.5-18.3-4.8c-1.5-0.9-0.6-2.4-0.6-3.9 c0-1.2,0.9-0.9,1.8-0.9c3.6-0.6,6.9-1.8,10.2-3.6c9.3-5.4,10.2-16.5,1.8-22.8c-9-6.9-22.5-6.9-31.5,0c-7.8,5.7-7.8,15.6,0,21.6 c3.3,2.7,7.2,3.9,11.1,4.8c0.6,0,1.2,0,1.5,0.6c0.6,1.2,0,3.9-1.2,4.8c-2.7,1.8-5.4,2.7-8.4,3.9c-3.9,1.2-7.5,1.5-11.1,0.3 c-5.1-1.5-8.4-5.7-11.1-10.2c-0.6-0.9-1.2-1.8-2.4-1.2c-1.2,0.6-0.9,1.8-0.3,2.7c2.4,4.2,5.4,7.8,9.9,10.2c1.2,0.6,1.8,1.5,2.4,3 c3.6,11.1,10.2,19.5,22.2,22.5c0.3,0.6,0.9,0.6,1.2,0.3C169.3,202.7,170.8,202.7,172,202.7z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#FEFEFE",
                    d: "M193,254.3c-0.9-0.6-1.2-2.7-3-1.8c-1.8,1.2-0.3,2.4,0.3,3.6c2.7,5.7,3.6,11.7,3.9,17.7 c-0.6,1.5-0.3,3,0,4.5l0,0c-0.9-0.3-1.5,0.3-2.1,0.9c-2.4,2.7-5.4,4.5-8.7,5.7c-8.7,3.6-17.4,3.9-26.1,0.6 c-3.6-1.2-6.6-3.6-9.6-5.7c0-0.9,0-1.5-0.3-2.4c0.6-0.3,0.6-0.6,0-0.9c-0.3-7.2,0.6-14.1,3-20.7c0.3-1.2,1.5-2.4,0-3.3 c-1.5-0.9-2.1,0.9-2.7,1.8c-1.8-0.9-2.4-2.4-3.6-3.9c-4.2-6.6-7.2-13.8-9.3-21.3c-1.2-3.9-2.4-7.8-2.4-11.7c1.5,0.3,3,0.6,4.5,1.2 c10.2,2.7,20.7,3.9,31.2,3.9c3.6,0,7.5,0,11.1-0.3c6.6-0.3,13.2-1.5,19.8-3c3.3-0.6,6.3-1.5,9.6-2.1c0,0.9,0,1.5-0.3,2.4 c-1.5,8.1-3.9,15.9-7.5,23.1C198.4,246.5,196.3,251,193,254.3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#F3A32F",
                    d: "M193,254.3c3.6-3.3,5.7-7.5,7.5-11.7c3.6-7.5,6-15,7.5-23.1c0-0.9,0-1.5,0.3-2.4l0.3-0.3 c5.1-1.5,9.9-3.3,15-5.4c2.4-0.9,4.2-2.4,6.9-2.4c3.3,6,5.7,12.3,7.2,18.9c1.8,7.8,2.7,15.6,2.4,23.7c0,1.5-0.3,3-0.6,4.5 c-0.9,0-0.9,0.9-1.2,1.5c-3.3,7.5-9.6,11.4-17.1,13.8c-4.2,1.2-8.7,1.8-12.9,2.7c-3.6,0.9-7.5,1.5-11.1,2.1 C197.2,268.4,195.7,261.2,193,254.3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#F3A32F",
                    d: "M132.1,217.1c0,4.2,1.2,8.1,2.4,11.7c2.4,7.5,5.1,14.7,9.3,21.3c0.9,1.5,1.8,3,3.6,3.9 c-0.6,3.3-1.8,6.3-2.4,9.6c-0.6,4.2-0.9,8.4-1.2,12.6c-5.4-3.6-11.7-4.5-18-4.8c-3.9-0.3-8.1,0-12-1.5c-4.5-1.5-7.8-4.5-9.9-8.7 c-1.2-2.4-1.8-5.1-3.3-7.5c-0.6-6.6,0-13.2,0.9-19.8c1.5-9,4.2-17.7,8.7-25.8c0.3,0,0.6,0,0.9,0c3.3,1.8,6.6,3.3,9.9,4.8 c3.6,1.2,6.9,3,10.8,3.3C132.1,216.8,132.1,217.1,132.1,217.1z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#F65A4E",
                    d: "M82.6,108.2c-1.5-3.6-2.4-6.9-3.3-10.2c-3-13.2-3.9-26.4-3.3-39.9c0.6-10.5,1.8-20.7,5.4-30.6 c1.2-3,2.4-5.7,3.9-8.4c0.6-1.2,1.2-1.5,2.7-0.6c8.4,4.8,14.4,11.7,18,20.4c4.2,9.6,4.8,19.2,1.8,29.1c-0.6,2.4-2.7,4.2-4.2,6.3 c-7.5,10.5-14.7,21.3-20.4,33C83.2,107.6,82.9,107.6,82.6,108.2z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#F65A4E",
                    d: "M257.5,106.4c-2.1-3.6-3.6-6.9-5.4-10.2c-5.1-9-11.1-17.7-18-25.5c-2.1-2.4-2.4-4.8-2.7-7.5 c-1.8-18.6,5.4-33.3,20.4-44.1c1.5-0.9,2.1-0.9,3,0.6c5.1,7.8,7.8,16.5,9,25.5c1.8,12.6,1.5,25.2-0.6,38.1 c-1.2,7.2-3,14.1-5.1,21.3C258.1,104.9,257.8,105.5,257.5,106.4z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D5D4D2",
                    d: "M77.8,156.8c0.6,0,0.9,0.6,1.2,1.2c2.4,6.3,6.6,11.4,11.4,15.9c5.4,5.1,11.7,9.6,18.3,13.2 c9.3,5.1,18.9,9,29.1,11.4c7.2,1.8,14.7,3.3,22.2,4.2c6.9,0.6,14.1,0.9,21,0.6c6.9,0,13.8-0.9,20.7-2.4c9.3-2.1,18.6-5.1,27-9.9 c5.1-3,9.9-6.3,14.1-10.2c6.3-5.7,11.4-12,15.6-19.2c2.1-3.3,3.6-6.9,5.1-10.5c0.3-0.6,0.3-1.5,1.5-1.8c-0.3,8.4-2.1,15.9-6.3,23.1 c-6.3,11.1-15.6,18.6-26.7,24.6c-9.9,5.1-20.1,9-30.9,11.1c-11.1,2.1-22.5,2.4-33.9,2.1c-14.4-0.3-28.5-2.4-42.3-6.6 c-12.6-3.9-24-9.9-33.3-19.5c-6.9-7.2-11.4-15.6-13.5-25.2C77.8,158,77.5,157.4,77.8,156.8z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M257.2,265.1c-0.3,5.4-2.7,11.7-6,18c0,0,0,0.3-0.3,0.3c-2.4,4.5-2.4,4.5-7.5,3.3c-0.3,0-0.6,0-0.9,0 c-1.2,0-2.1,0-2.1,1.2c0,1.2,0.6,1.8,1.8,1.8c2.7,0.3,5.4,0.9,7.8,2.1c4.8,2.4,6.3,6.9,3.3,10.5s-6.9,4.8-11.4,4.5 c-5.1-0.6-9.3-3.3-13.2-6.6c-0.9-0.9-0.9-1.5-0.3-2.4c6-8.7,9.9-18.3,12.6-28.8c1.5-6.6,2.4-13.5,2.4-20.1c0-1.5,0.3-2.1,1.8-1.5 C253.3,249.5,257.2,254.6,257.2,265.1z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M97.6,305.9c-3.9,0-6.9-0.9-9-3.6c-3-3.6-1.8-8.1,3-10.8c2.1-1.2,4.5-2.1,7.2-2.7c1.2-0.3,2.1-0.6,1.8-2.1 c-0.3-1.2-1.5-0.9-2.4-0.9c-1.2,0.3-2.7,0.6-3.6,1.2c-0.9,0.3-1.5,0.3-2.1-0.6c-4.5-7.2-7.8-15-8.1-23.7 c-0.3-8.1,3.9-13.2,11.4-15.6c1.8-0.6,2.1-0.3,2.1,1.5c-0.3,9.6,1.2,19.2,3.9,28.2c2.1,7.2,5.1,14.1,9.6,20.1 c0.6,0.6,1.2,1.2,0.3,2.1C107.2,303.2,102.7,305.9,97.6,305.9z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D5D4D2",
                    d: "M132.1,217.1l-0.3-0.3c0-2.7,0-5.1,0-7.8c15.6,3.6,31.2,5.1,47.4,4.5c9.9-0.3,19.5-1.2,29.1-3.9 c0.6,2.1,0,4.5,0.3,6.6l-0.3,0.3c-3.3,0.6-6.3,1.5-9.6,2.1c-6.6,1.5-12.9,2.4-19.8,3c-3.6,0.3-7.5,0.3-11.1,0.3 c-10.5,0-21-1.2-31.2-3.9C135.1,218,133.6,217.4,132.1,217.1z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D5D4D2",
                    d: "M147.7,279.8c3,2.1,6,4.5,9.6,5.7c8.7,3,17.4,3,26.1-0.6c3.3-1.5,6.3-3,8.7-5.7c0.6-0.6,1.2-1.2,2.1-0.9 c0,3,0,6-2.4,8.7c-2.1,2.4-3,5.4-3.3,8.7c0,0.9-0.3,1.2-1.2,1.8c-11.4,4.8-23.1,4.8-34.5,0c-0.9-0.3-1.2-0.6-1.2-1.8 c0.3-2.7-0.6-5.1-1.8-7.5C148,285.5,147.7,282.8,147.7,279.8z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M100.6,254c1.5,2.4,2.1,5.1,3.3,7.5c2.4,4.2,5.4,7.2,9.9,8.7c3.9,1.5,8.1,1.2,12,1.5 c6.3,0.3,12.6,1.2,18,4.8c0,2.1,0.3,4.2,0.6,6.6c-2.7-1.8-5.1-3-8.1-3.6c-9.6-2.4-20.4,3.9-22.8,13.5c0,0.6,0,1.5-0.6,1.5 c-0.6,0-0.9-0.9-1.5-1.5c-3.9-6-6.3-12.3-8.1-19.2c-1.8-6.3-2.4-12.6-3-19.2C100.6,254.6,100.6,254.3,100.6,254z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M197.2,275.9c3.6-0.6,7.5-1.5,11.1-2.1c4.2-0.9,8.7-1.5,12.9-2.7c7.5-2.4,13.5-6.6,17.1-13.8 c0.3-0.6,0.3-1.5,1.2-1.5c0,4.5-0.9,9-2.1,13.5c-2.1,8.7-5.7,16.8-10.2,24.3c-0.3,0.3-0.3,0.6-0.9,0.6c-0.9-6.9-5.1-11.1-11.1-13.8 c-6-2.7-12.3-2.1-18,1.2C197.2,279.5,197.2,277.7,197.2,275.9z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M139.6,294.5c0,2.4-0.3,4.5-0.9,6.3c-1.5,4.2-7.5,5.7-11.1,3c-1.2-0.9-0.9-2.1-1.2-3.3 c-1.5-6-0.9-11.7,2.4-16.8c1.5-2.7,6.6-2.7,8.1,0C139,287,139.6,290.9,139.6,294.5z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M200.8,295.4c0-4.5,0.9-8.4,3.3-12c1.5-2.1,6.3-2.1,7.8,0.3c3.3,5.7,3.9,12,1.5,18.3 c-1.5,4.5-8.1,4.5-10.5,2.1c-1.5-1.5-1.5-3.6-1.8-5.7C200.8,297.2,200.8,296.3,200.8,295.4z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M131.8,209c0,2.7,0,5.1,0,7.8c-3.9-0.3-7.2-2.1-10.8-3.3c-3.6-1.2-6.9-2.7-9.9-4.8c-0.3,0-0.6,0-0.9,0 c1.2-1.8,1.8-4.5,3.6-5.1c1.5-0.6,3.9,1.2,5.7,1.8C123.7,206.6,127.9,207.8,131.8,209z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M208.6,216.2c0-2.1,0.3-4.5-0.3-6.6c4.5-1.8,9.3-3,13.8-4.8c0.9-0.3,1.8-0.6,2.4-0.9 c1.8-1.2,2.7-0.6,3.6,1.2c0.6,1.2,1.2,2.4,2.1,3.6c-2.7,0-4.5,1.5-6.9,2.4C218.5,212.9,213.7,214.7,208.6,216.2z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M200.2,283.7c-2.7,6-3.3,12-1.8,18c0.3,0.9,0,1.5-0.9,1.5c-3.6,0.3-6.3-1.8-6.3-5.1 C190.9,291.8,194.5,286.1,200.2,283.7z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M124.9,284c-0.3,2.7-1.5,4.8-1.8,7.5c-0.3,3.3-0.3,6.6,0.6,9.9c0.3,1.8-0.3,1.8-1.8,1.8 c-3.3,0-5.4-2.1-5.7-5.4c0-6,2.7-10.5,7.8-13.8C124,284,124.6,284,124.9,284L124.9,284z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M141.1,284.6c4.5,1.2,7.8,7.5,7.2,12.3c-0.3,2.1-0.9,3.9-2.1,5.4c-0.6,0.6-1.5,1.2-2.4,1.2s-2.4,0-2.1-1.8 c1.5-5.7,1.2-11.4-0.6-16.8C141.1,284.9,141.1,284.9,141.1,284.6z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M216.1,284.6c6.6,2.4,9.6,12.3,5.1,17.7c-0.6,0.9-1.5,1.2-2.4,1.5c-1.5,0.3-2.4-0.9-2.1-2.1 c1.8-5.1,1.2-10.2-0.3-15.3C216.1,285.8,215.8,285.2,216.1,284.6L216.1,284.6z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D5D4D2",
                    d: "M193.9,278.3c0-1.5-0.3-3,0-4.5C194.2,275.3,194.5,276.8,193.9,278.3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D5D4D2",
                    d: "M147.4,276.5c0.6,0.3,0.6,0.6,0,0.9C147.1,277.1,147.1,276.8,147.4,276.5z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M124.9,284L124.9,284L124.9,284L124.9,284L124.9,284z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#CA8929",
                    d: "M216.1,284.6C216.1,284.3,216.1,284.3,216.1,284.6C216.1,284.3,216.1,284.3,216.1,284.6 C216.1,284.3,216.1,284.3,216.1,284.6L216.1,284.6z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#3F1C10",
                    d: "M233.5,115.4c0,7.2-2.1,13.8-7.5,18.9c-8.1,7.8-19.5,7.5-26.7-1.5c-6.6-8.1-7.8-17.1-4.8-26.7 c1.5-5.1,4.5-9.3,9-12.3c6.9-4.5,15.6-3.9,21.6,1.8C230.8,101,233.2,107.9,233.5,115.4z M221.5,107.6c0-3-0.9-5.7-3-7.5 c-3.3-3.3-7.8-3.3-11.1,0c-3.9,3.9-3.6,11.4,0.3,15c2.4,2.1,5.1,2.7,8.1,1.5C219.7,115.1,221.5,111.8,221.5,107.6z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#3F1C10",
                    d: "M107.8,117.5c0-10.5,3-18,9.9-23.1c7.5-5.4,16.5-4.5,23.4,2.7c9.3,9.3,9,28.2-0.3,37.2 c-9.3,9-23.1,6.9-29.4-4.5C109,125.3,107.5,120.8,107.8,117.5z M136.3,107.6c0-0.3,0-0.9,0-1.5c-0.6-3.6-2.4-6.6-6-7.8 c-3.3-1.2-6-0.3-8.4,2.1c-3.9,3.9-3.3,11.4,0.6,15c3.6,3,8.4,2.7,11.4-1.2C135.4,112.4,136.6,110.3,136.3,107.6z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#3F1C10",
                    d: "M166.9,202.4c-12-2.7-18.6-11.1-22.2-22.5c-0.3-1.2-0.9-2.1-2.4-3c-4.5-2.4-7.5-6-9.9-10.2 c-0.6-0.9-0.9-2.1,0.3-2.7c1.2-0.6,1.8,0.3,2.4,1.2c2.7,4.5,6,8.4,11.1,10.2c3.6,1.2,7.5,0.9,11.1-0.3c3-0.9,5.7-2.1,8.4-3.9 c1.2-0.6,1.8-3.6,1.2-4.8c-0.3-0.6-0.9-0.6-1.5-0.6c-4.2-0.9-7.8-2.1-11.1-4.8c-7.5-6-7.5-15.6,0-21.6c9-6.9,22.5-6.9,31.5,0 c8.4,6.3,7.5,17.7-1.8,22.8c-3.3,1.8-6.6,3-10.2,3.6c-0.6,0-1.8-0.3-1.8,0.9c0,1.2-0.9,3,0.6,3.9c5.7,3,11.4,5.7,18.3,4.8 c6-0.9,10.2-3.9,13.2-9c0.3-0.6,0.6-1.2,0.9-1.5c0.6-0.9,1.2-1.5,2.1-0.9c0.9,0.6,0.9,1.5,0.6,2.4c-0.9,1.5-1.5,2.7-2.4,3.9 c-2.1,2.7-4.5,4.8-7.5,6.3c-0.9,0.3-1.5,0.9-1.8,2.1c-2.1,5.1-4.5,9.9-8.1,14.1c-4.2,5.1-9.3,8.1-15.6,9.6c-0.3-0.3-0.6,0-0.9,0 c-1.2,0-2.4,0-3.6,0C167.8,202.4,167.2,202.4,166.9,202.4z M169,180.5c-6,0.3-12,1.8-16.5,6.9c-0.6,0.9-0.9,1.2,0,2.1 c1.5,1.8,2.7,3.6,4.5,5.1c5.1,3.9,10.5,6,17.1,4.5c5.7-1.2,9.9-4.8,13.2-9.3c1.8-2.1,1.5-2.4-0.6-3.9 C181.6,182.3,175.9,180.8,169,180.5z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D5D4D2",
                    d: "M166.9,202.4c0.6-0.3,0.9,0,1.2,0.3C167.8,203.3,167.2,203.3,166.9,202.4z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D5D4D2",
                    d: "M172,202.7c0.3-0.3,0.6-0.3,0.9,0C172.6,203,172.3,203.3,172,202.7z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#FEFEFE",
                    d: "M221.5,107.6c0,4.2-1.8,7.2-5.7,9c-3,1.2-5.7,0.6-8.1-1.5c-4.2-3.6-4.5-11.1-0.3-15c3.3-3.3,7.8-3.3,11.1,0 C220.6,102.2,221.8,104.6,221.5,107.6z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#FEFEFE",
                    d: "M136.3,107.6c0.3,2.7-0.9,4.8-2.1,6.6c-3,3.6-7.8,4.2-11.4,1.2c-4.2-3.6-4.5-11.1-0.6-15 c2.4-2.4,5.1-3.3,8.4-2.1c3.6,1.2,5.4,4.2,6,7.8C136.3,106.7,136.3,107.3,136.3,107.6z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#F65A4E",
                    d: "M169,180.5c6.9,0.3,12.6,1.8,17.4,5.4c2.4,1.5,2.4,1.8,0.6,3.9c-3.6,4.5-7.5,8.1-13.2,9.3 c-6.6,1.5-12-0.6-17.1-4.5c-1.8-1.5-3.3-3.3-4.5-5.1c-0.6-0.9-0.6-1.2,0-2.1C157.3,182.6,163.3,180.8,169,180.5z"
                })
            ]
        })
    }));
};
/* harmony default export */ var PanIcon = (Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% { transform: scale(1); }\n  10% { transform: scale(1.1); }\n  20% { transform: scale(1.2); }\n  30% { transform: scale(1.3); }\n  40% { transform: scale(1.4); }\n  50% { transform: scale(1.5); }\n  60% { transform: scale(1.4); }\n  70% { transform: scale(1.3); }\n  80% { transform: scale(1.2); }\n  90% { transform: scale(1.1); }\n  100% { transform: scale(1); }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nfrom {\n  transform:rotate(0deg);\n}\nto {\n  transform:rotate(360deg);\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  animation: ",
        " 4s linear infinite;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // position: absolute;\n  top: 0;\n  left: 0;\n  animation: ",
        " 2s linear infinite;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var pulse = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var spin = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f76e36a-0"
}).withConfig({
    componentId: "sc-1e428479-0"
})(_templateObject2(), pulse);
var FloatingPanIcon = (0,styled_components_browser_esm/* default */.ZP)(PanIcon).withConfig({
    componentId: "sc-8f76e36a-1"
}).withConfig({
    componentId: "sc-1e428479-1"
})(_templateObject3(), spin);
var Spinner = function Spinner(param) {
    var _size = param.size, size = _size === void 0 ? 128 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingPanIcon, {
            width: "".concat(size, "px")
        })
    });
};
/* harmony default export */ var Spinner_Spinner = (Spinner);


/***/ })

}]);